import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import Dialpad from './dialpad-icon.svg';

function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <Dialpad {...validProps} />;
}
SvgComponent.iconName = 'dialpad';

export const DialpadIcon = svgIconWrapper(SvgComponent);
